import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, Paper, useMediaQuery, useTheme } from "@mui/material";
import FacebookCircularProgress from "../../shared/shared/Loading";

export default function PromoEffectivenessOverTimeChart() {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [xAxisCategories, setXAxisCategories] = useState([]);

  const colorPalette = [
    "#255e91", 
    "#53b5ff", 
    "#fbc210", 
    "#666666", 
    "#ff6b6b", 
    "#4ecdc4", 
    "#ff9f43", 
    "#5f27cd", 
    "#00d2d3", 
    "#ff6348" 
  ];

  // const fetchData = async () => {
  //   if (!projectId) {
  //     setError("Project ID not found.");
  //     setLoading(false);
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     setIsRefreshing(true);
  //     setError(null);
      
  //     const dateRange = `["${startDate.format('YYYY-MM-DD')}","${endDate.format('YYYY-MM-DD')}"]`;
  //     const apiUrl = `${getUrl()}/strategy_creation/promo_effective?project_id=${projectId}&hierarchy=${selectedHierarchy}&date_range=${dateRange}&filters={}`;
      
  //     console.log("API URL:", apiUrl);
      
  //     const response = await fetch(apiUrl, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
  //       },
  //     });
      
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
  //     }
      
  //     const data = await response.json();
      
  //     const chartSeries = [];
  //     const { date, ...brands } = data;
      
  //     const sortedDates = [...date].sort((a, b) => {
  //       const dateA = new Date(a.replace(/(\w{3}) (\d{2})/, '$1 01, 20$2'));
  //       const dateB = new Date(b.replace(/(\w{3}) (\d{2})/, '$1 01, 20$2'));
  //       return dateA - dateB;
  //     });

  //     Object.entries(brands).forEach(([brandName, values], index) => {
  //       if (brandName !== 'date') {
  //         const brandData = sortedDates.map((dateStr) => {
  //           const originalIndex = date.indexOf(dateStr);
  //           return {
  //             x: dateStr,
  //             y: values[originalIndex]
  //           };
  //         });

  //         const colorIndex = index % colorPalette.length;
  //         const brandColor = colorPalette[colorIndex];

  //         chartSeries.push({
  //           name: brandName,
  //           data: brandData,
  //           color: brandColor
  //         });
  //       }
  //     });

  //     setSeries(chartSeries);
  //     setError(null);
  //   } catch (err) {
  //     console.error('Error fetching promo effectiveness data:', err);
  //     setError('Failed to load data');
  //     setSeries([]);
  //   } finally {
  //     setLoading(false);
  //     setIsRefreshing(false);
  //   }
  // };

  // const handleRefresh = () => {
  //   fetchData();
  // };

  // useEffect(() => {
  //   function fetchHierarchyLevels() {
  //     if (!projectId) {
  //       console.warn("Project ID is not set in Redux state.");
  //       return;
  //     }
  //     fetch(`${getUrl()}/market_overview/hierarchy`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
  //       },
  //       body: JSON.stringify({ project_id: projectId }),
  //     })
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! Status: ${response.status}`);
  //         }
  //         return response.json();
  //       })
  //       .then((result) => {
  //         console.log("result from hierarchy", result);
          
  //         if (!result["0"] || Object.keys(result["0"]).length === 0) {
  //           throw new Error("No hierarchy data available");
  //         }
          
  //         const allowedHierarchyLevels = ["brand", "class", "manufacturer"];
  //         const rawHierarchyLevels = Object.keys(result["0"] || {}); 
  //         const hierarchyLevels = rawHierarchyLevels.filter((key) =>
  //           allowedHierarchyLevels.includes(key)
  //         );
  //         hierarchyLevels.push("channel", "retailer");
  //         setHierarchyOptions(hierarchyLevels);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching hierarchy levels:", error);
  //       });
  //   }

  //   fetchHierarchyLevels();
  // }, [projectId]);

  // useEffect(() => {
  //   fetchData();
  // }, [projectId, selectedHierarchy, startDate, endDate, timePeriod, target]);

  useEffect(() => {
    const staticData = [
  {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":1,
        "value_sales":435731.77,
        "volume_sales":35994.1,
        "volume_sales_R":6284.4,
        "volume_sales_CP":22625.0,
        "volume_sales_PX":7084.7,
        "count_CP":873,
        "count_PX":181,
        "VSOD":29709.7,
        "uplift_volume_CP":16340.6,
        "uplift_volume_PX":800.3,
        "productivity_CP":18.717755,
        "productivity_PX":4.421547
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":2,
        "value_sales":480705.26,
        "volume_sales":51126.6,
        "volume_sales_R":5784.0,
        "volume_sales_CP":45342.6,
        "volume_sales_PX":0.0,
        "count_CP":897,
        "count_PX":0,
        "VSOD":45342.6,
        "uplift_volume_CP":39558.6,
        "uplift_volume_PX":-5784.0,
        "productivity_CP":44.101003,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":3,
        "value_sales":656448.41,
        "volume_sales":69271.3,
        "volume_sales_R":21548.7,
        "volume_sales_CP":43975.6,
        "volume_sales_PX":0.0,
        "count_CP":715,
        "count_PX":0,
        "VSOD":47722.6,
        "uplift_volume_CP":22426.9,
        "uplift_volume_PX":-21548.7,
        "productivity_CP":31.366294,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":4,
        "value_sales":546963.29,
        "volume_sales":62351.5,
        "volume_sales_R":26109.3,
        "volume_sales_CP":15212.2,
        "volume_sales_PX":0.0,
        "count_CP":777,
        "count_PX":0,
        "VSOD":36242.2,
        "uplift_volume_CP":-10897.1,
        "uplift_volume_PX":-26109.3,
        "productivity_CP":-14.024582,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":5,
        "value_sales":327085.68,
        "volume_sales":28518.4,
        "volume_sales_R":4449.2,
        "volume_sales_CP":24069.2,
        "volume_sales_PX":0.0,
        "count_CP":710,
        "count_PX":0,
        "VSOD":24069.2,
        "uplift_volume_CP":19620.0,
        "uplift_volume_PX":-4449.2,
        "productivity_CP":27.633803,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":6,
        "value_sales":251558.11,
        "volume_sales":23154.6,
        "volume_sales_R":3217.5,
        "volume_sales_CP":19937.1,
        "volume_sales_PX":0.0,
        "count_CP":852,
        "count_PX":0,
        "VSOD":19937.1,
        "uplift_volume_CP":16719.6,
        "uplift_volume_PX":-3217.5,
        "productivity_CP":19.623944,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":7,
        "value_sales":304042.81,
        "volume_sales":28909.9,
        "volume_sales_R":4304.2,
        "volume_sales_CP":24605.7,
        "volume_sales_PX":0.0,
        "count_CP":1007,
        "count_PX":0,
        "VSOD":24605.7,
        "uplift_volume_CP":20301.5,
        "uplift_volume_PX":-4304.2,
        "productivity_CP":20.160377,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":8,
        "value_sales":265573.61,
        "volume_sales":25825.3,
        "volume_sales_R":3807.2,
        "volume_sales_CP":21562.1,
        "volume_sales_PX":0.0,
        "count_CP":702,
        "count_PX":0,
        "VSOD":22018.1,
        "uplift_volume_CP":17754.9,
        "uplift_volume_PX":-3807.2,
        "productivity_CP":25.29188,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":9,
        "value_sales":243996.51,
        "volume_sales":22052.6,
        "volume_sales_R":3812.3,
        "volume_sales_CP":18240.3,
        "volume_sales_PX":0.0,
        "count_CP":870,
        "count_PX":0,
        "VSOD":18240.3,
        "uplift_volume_CP":14428.0,
        "uplift_volume_PX":-3812.3,
        "productivity_CP":16.583908,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":10,
        "value_sales":307902.69,
        "volume_sales":26491.4,
        "volume_sales_R":5342.0,
        "volume_sales_CP":21149.4,
        "volume_sales_PX":0.0,
        "count_CP":995,
        "count_PX":0,
        "VSOD":21149.4,
        "uplift_volume_CP":15807.4,
        "uplift_volume_PX":-5342.0,
        "productivity_CP":15.886834,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":11,
        "value_sales":256028.56,
        "volume_sales":23804.3,
        "volume_sales_R":4333.8,
        "volume_sales_CP":19470.5,
        "volume_sales_PX":0.0,
        "count_CP":863,
        "count_PX":0,
        "VSOD":19470.5,
        "uplift_volume_CP":15136.7,
        "uplift_volume_PX":-4333.8,
        "productivity_CP":17.539629,
        "productivity_PX":null
    },
    {
        "class":"SUNFLOWER OIL",
        "year":2024,
        "month":12,
        "value_sales":255417.44,
        "volume_sales":21085.3,
        "volume_sales_R":4196.5,
        "volume_sales_CP":16888.8,
        "volume_sales_PX":0.0,
        "count_CP":889,
        "count_PX":0,
        "VSOD":16888.8,
        "uplift_volume_CP":12692.3,
        "uplift_volume_PX":-4196.5,
        "productivity_CP":14.277053,
        "productivity_PX":null
    }
];

    try {
    setLoading(true);
    setIsRefreshing(true);
    setError(null);

    const afiaData = staticData.filter(item => item.segment === "AFIA");
    const sortedData = [...afiaData].sort((a, b) => a.date - b.date);

    const categories = [];
    const baselineCP = [];
    const baselinePX = [];
    const upliftVolumeCP = [];
    const upliftVolumePX = [];
    const volumeCP = [];
    const volumePX = [];

    const formatDate = (timestamp) => {
      const date = new Date(timestamp);
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                         "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear().toString().slice(-2);
      return `${month}-${year}`;
    };

    sortedData.forEach((item) => {
      categories.push(formatDate(item.date));
      baselineCP.push(Math.round(item.baseline_CP || 0));
      baselinePX.push(Math.round(item.baseline_PX || 0));
      upliftVolumeCP.push(Math.round(item.uplift_volume_CP || 0));
      upliftVolumePX.push(Math.round(item.uplift_volume_PX || 0));
      volumeCP.push(Math.round(item.volume_CP || 0));
      volumePX.push(Math.round(item.volume_PX || 0));
    });

    const chartSeries = [
      { name: "Baseline CP", data: baselineCP, color: colorPalette[0] },
      { name: "Baseline PX", data: baselinePX, color: colorPalette[1] },
      { name: "Uplift Volume CP", data: upliftVolumeCP, color: colorPalette[2] },
      { name: "Uplift Volume PX", data: upliftVolumePX, color: colorPalette[3] },
      { name: "Volume CP", data: volumeCP, color: colorPalette[4] },
      { name: "Volume PX", data: volumePX, color: colorPalette[5] },
    ];

    setXAxisCategories(categories);
    setSeries(chartSeries);
    setError(null);
  } catch (err) {
    console.error("Error loading promo effectiveness data:", err);
    setError("Failed to load data");
    setSeries([]);
  } finally {
    setLoading(false);
    setIsRefreshing(false);
  }
}, []);


  const handleRefresh = () => {
    window.location.reload();
  };

  const fmtInt = (v) =>
  Number.isFinite(v) ? v.toLocaleString("en-US", { maximumFractionDigits: 0 }) : "0";

const options = {
  chart: {
    type: "line",
    toolbar: { show: false },
    fontFamily: "Barlow Semi Condensed, sans-serif",
    height: "100%",
  },
  colors: series.map((s) => s.color),
  stroke: {
    curve: "smooth",
    width: isSmallMobile ? 2 : isMobile ? 2.5 : 2,
  },
  markers: {
    size: isSmallMobile ? 3 : isMobile ? 4 : 4,
    strokeWidth: isSmallMobile ? 2 : 2,
    hover: {
      size: isSmallMobile ? 5 : 6,
    },
  },
  xaxis: {
    categories: xAxisCategories,
    labels: {
      style: { 
        fontSize: isSmallMobile ? "9px" : isMobile ? "11px" : "11px",
        fontWeight: isSmallMobile ? "500" : "normal"
      },
      rotate: isSmallMobile ? -45 : isMobile ? -45 : -45,
      rotateAlways: true,
      hideOverlappingLabels: isSmallMobile ? true : false,
      trim: false,
    },
    title: {
      text: "Month",
      style: { 
        fontSize: isSmallMobile ? "10px" : isMobile ? "12px" : "14px", 
        fontWeight: "bold" 
      },
    },
  },
  yaxis: [
    {
      title: {
        text: isSmallMobile ? "Volume" : "Volume (CP / PX)",
        style: { 
          fontSize: isSmallMobile ? "10px" : isMobile ? "12px" : "14px", 
          fontWeight: "bold" 
        },
      },
      min: undefined,
      tickAmount: isSmallMobile ? 3 : isMobile ? 4 : 5,
      labels: {
        style: {
          fontSize: isSmallMobile ? "9px" : isMobile ? "10px" : "11px"
        },
        formatter: (val) => fmtInt(val),
      },
    },
  ],
  grid: {
    borderColor: "#E0E0E0",
    strokeDashArray: isSmallMobile ? 2 : 4,
  },
  legend: {
    show: true,
    position: isSmallMobile ? "bottom" : "top",
    horizontalAlign: "center",
    fontSize: isSmallMobile ? "10px" : isMobile ? "11px" : "12px",
    markers: {
      width: isSmallMobile ? 6 : 8,
      height: isSmallMobile ? 6 : 8,
      radius: isSmallMobile ? 3 : 4,
    },
    itemMargin: {
      horizontal: isSmallMobile ? 6 : 10,
      vertical: isSmallMobile ? 3 : 5,
    },
  },
  tooltip: {
    shared: true,
    intersect: false,
    style: {
      fontSize: isSmallMobile ? "11px" : "12px"
    },
    y: {
      formatter: (val) => fmtInt(val),
    },
  },
  responsive: [
    {
      breakpoint: 600,
      options: {
        chart: {
          height: 350,
        },
        legend: {
          position: "bottom",
          fontSize: "9px",
          markers: {
            width: 6,
            height: 6,
            radius: 3,
          },
        },
        xaxis: {
          labels: { 
            style: { fontSize: "9px" }, 
            rotate: -45 
          },
          title: {
            style: { fontSize: "10px" }
          }
        },
        yaxis: {
          labels: { 
            style: { fontSize: "9px" } 
          },
          title: {
            style: { fontSize: "10px" }
          }
        },
        stroke: {
          width: 2,
        },
        markers: {
          size: 3,
          strokeWidth: 2,
        },
      },
    },
    {
      breakpoint: 768,
      options: {
        chart: {
          height: 400,
        },
        legend: {
          fontSize: "10px",
        },
        xaxis: {
          labels: { 
            style: { fontSize: "9px" }, 
            rotate: -45 
          },
        },
        yaxis: {
          labels: { 
            style: { fontSize: "9px" } 
          },
        },
      },
    },
  ],
};

  return (
    <Box sx={{ 
      width: "100%", 
      minWidth: { xs: "400px", sm: "500px", md: "800px" },
      maxWidth: "100%",
      overflow: "hidden"
    }}>
      <Typography
        align="center"
        fontWeight={500}
        mb={1}
        sx={{ 
          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
          px: { xs: 1, sm: 0 }
        }}
      >
        Promo Effectiveness Over Time
      </Typography>
      <Typography
        align="center"
        fontWeight={400}
        mb={2}
        sx={{
          fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
          color: "#003dc2",
          px: { xs: 1, sm: 0 }
        }}
      >
        Savola | Afia
      </Typography>

      {loading || isRefreshing ? (
        <Paper
          elevation={2}
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <FacebookCircularProgress loading={true} />
          </Box>
        </Paper>
      ) : error ? (
        <Paper
          elevation={2}
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <FacebookCircularProgress
              loading={false}
              hasData={false}
              onRefresh={handleRefresh}
              message={`Error: ${error} - Click to retry`}
            />
          </Box>
        </Paper>
      ) : series.length === 0 ? (
        <Paper
          elevation={2}
          sx={{
            p: 2,
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <FacebookCircularProgress
              loading={false}
              hasData={false}
              onRefresh={handleRefresh}
              message="No data available - Click to refresh"
            />
          </Box>
        </Paper>
      ) : (
        <Paper
          elevation={2}
          sx={{
            p: { xs: 1, sm: 2 },
            width: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            borderRadius: { xs: "6px", sm: "8px" },
            boxShadow: { xs: "0 1px 4px rgba(0,0,0,0.06)", sm: "0 2px 8px rgba(0,0,0,0.1)" }
          }}
        >
          <Box sx={{ 
            width: "100%", 
            overflow: "auto",
            "&::-webkit-scrollbar": {
              height: { xs: "4px", sm: "6px" },
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f5f5f5",
              borderRadius: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#bdbdbd",
              borderRadius: "3px",
              "&:hover": {
                backgroundColor: "#9e9e9e",
              },
            },
          }}>
            <ReactApexChart
              options={options}
              series={series}
              type="line"
              height={isSmallMobile ? 350 : isMobile ? 450 : 500}
              width="100%"
            />
          </Box>
        </Paper>
      )}
    </Box>
  );
}
